import React, { useState, useEffect, lazy, Suspense } from 'react'
import intl from 'react-intl-universal';
import { Button, ImageViewer, FloatingBubble, Popup, Badge, SpinLoading } from 'antd-mobile'
import { CouponOutline, LeftOutline } from 'antd-mobile-icons'
import { useNavigate } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import { setAddCartFromActivity as setAddCartFromActivityRedux } from '../../../store/reducers/hotel'
import Article from '../../../components/Article'
import Header from '../../../components/Header'
import CouponList from '../../../components/CouponList'
import { getScopeParam, setAddCartFromActivity } from '../../../utils/session/store'
import { getMemberInfo } from '../../../utils/storage/store'
// import { getProductMenuModel } from '../../../model/store'
import defaultImg from '../../../assets/images/def_img_food.png'
import './index.less'
import { isURLValid, replaceCDNDomain, formatJSON, isVideoFile } from '../../../utils';
// import CouponIcon from '../../Icon/CouponIcon';
import Coupons from '../../../views/coupons';
import { getMyCouponCountModel } from '../../../model/store';
import { addBehaviorsRecord } from '../../../utils/BehaviorstatsHelp'
// 懒加载 react-player
const ReactPlayer = lazy(() => import('react-player'))
const PromotionDetail = ({ detail, callback, hideHeader = false, from = '', storeInfo = {} }) => {
    const [activityDetail, setActivityDetail] = useState(null)
    // const [couponData, setCouponData] = useState(null)
    const [loading, setLoading] = useState(false)
    const [couponVisible, setCouponVisible] = useState(false)
    const [couponCount, setCouponCount] = useState(0)
    const navigate = useNavigate()
    const dispatch = useDispatch()

    const { memberId = '' } = getMemberInfo() || {};
    const scopeParam = getScopeParam()
    // const navigate = useNavigate()
    const isCurrentView = window.location.href.includes('#/carte')
    console.log(detail, '///===//detial', from, isCurrentView)
    const {
        activityTitle, content, contentType = '',
        imageArray, param2, param4, relateId,
        extendColumn
    } = detail;
    const extendObj = formatJSON(extendColumn)
    const rawVideoUrl = extendObj?.videoUrl || ''
    const videoUrl = rawVideoUrl && rawVideoUrl.trim() ? rawVideoUrl.trim() : ''
    const firstImage = imageArray && imageArray.length > 0 ? replaceCDNDomain(imageArray[0]) : null;
    const bookActivity = (param2) => {
        if (!param2) return;
        // getProductMenuModel({
        //     productId: param2
        // }).then(res => {
        //     setActivityDetail(res)
        //     navigate(`/preview?storeId=${storeInfo.storeId}&areaId=${areaId}`, { state: { storeInfo, currentProduct: item, from } })

        // }).catch(err => {
        //     console.log(err, '///////err///////')
        // })
        callback && callback()
        addBehaviorsRecord({
            behaviorType: 160100,
            behavior: 160103,
            storeId: storeInfo.storeId,
            value1: 3,
            value2: detail.activityId,
            value3: detail.contentType,
            value4: param2
        })
        navigate(`/relate-product?productId=${param2}&activityId=${detail.activityId}`)
    }


    /*
    useEffect(() => {
        if (param2 && contentType === 3) {
            getCouponRuleDetailModel({
                couponRuleId: param2
            }).then(res => {
                console.log(res, '///////res///////')
                setCouponData(res)
            }).catch(err => {
                console.log(err, '///////err///////')
            })

        }
    }, [param2, contentType])
    //*/

    const getCouponCount = () => {
        const { memberId = '' } = getMemberInfo() || {};
        getMyCouponCountModel({ memberId, storeIdList: relateId, status: 1 }, true)
            .then(res => {
                // console.log(res, '///////res///////')
                let count = 0
                if (res.hasOwnProperty('data')) {
                    count = res.data || 0
                } else {
                    count = res
                }
                setCouponCount(count || 0)
            }).catch(err => {
                console.log(err, '///////err///////')
            })
    }
    useEffect(() => {

        if (contentType === 3 && param2) {
            getCouponCount()
        }
    }, [contentType, param2, relateId])

    useEffect(() => {
        const timeTicket = Date.now();

        // //页面进入时记录
        // addBehaviorsRecord({
        //     behaviorType: 160100,
        //     behavior: 160101,
        //     value1: detail.activityId,
        //     value3: detail.contentType
        // })
        return () => {
            const timeDiff = Date.now() - timeTicket;
            //记录页面停留时间
            addBehaviorsRecord({
                behaviorType: 160100,
                behavior: 160102,
                storeId: storeInfo.storeId,
                value1: detail.placeFlag,
                value2: detail.activityId,
                value3: parseInt(timeDiff / 1000), //stay page time(seconds)
            })
        }
    }, [detail.activityId, storeInfo.storeId])

    const processedVideoUrl = videoUrl ? replaceCDNDomain(videoUrl) : ''
    const isValidVideoUrl = videoUrl && (isURLValid(videoUrl) || isVideoFile(videoUrl))

    console.log({
        rawVideoUrl,
        videoUrl,
        processedVideoUrl,
        isValidVideoUrl,
        extendObj,
        extendColumn
    }, '/////videoUrl debug/////')

    return (
        <div className='pm-detail-wrapper' style={{ height: window.innerHeight, overflowY: 'auto', overflowX: 'hidden' }}>
            {!hideHeader && (<Header title={intl.get('h_detail').d('详情')} callback={callback} />)}
            <div className='pm-detail-main'>
                <div className='pm-item'>
                    {
                        isValidVideoUrl ? (
                            isVideoFile(videoUrl) ? (
                                // 视频文件使用原生 video 标签
                                <video
                                    controls
                                    muted
                                    controlsList="nodownload noremoteplayback noplaybackrate"
                                    style={{ width: '100%', display: 'block' }}
                                    onError={(e) => {
                                        console.error('视频加载错误:', e, processedVideoUrl)
                                    }}
                                    onLoadedData={() => {
                                        console.log('视频加载完成:', processedVideoUrl)
                                    }}
                                >
                                    <source src={processedVideoUrl} />
                                    您的浏览器不支持视频播放
                                </video>
                            ) : (
                                // 其他 URL（如 YouTube、HLS 等）使用 ReactPlayer
                                <div style={{ width: '100%', position: 'relative', paddingTop: '56.25%', backgroundColor: '#000' }}>
                                    <Suspense fallback={
                                        <div style={{
                                            position: 'absolute',
                                            top: '50%',
                                            left: '50%',
                                            transform: 'translate(-50%, -50%)',
                                            display: 'flex',
                                            flexDirection: 'column',
                                            alignItems: 'center',
                                            gap: '10px',
                                            color: '#fff'
                                        }}>
                                            <SpinLoading color="white" />
                                            <div>正在加载播放器...</div>
                                        </div>
                                    }>
                                        <ReactPlayer
                                            url={processedVideoUrl}
                                            width='100%'
                                            height='100%'
                                            style={{ position: 'absolute', top: 0, left: 0 }}
                                            controls
                                            playing={false}
                                            playsinline
                                            onReady={() => {
                                                console.log('视频准备就绪:', processedVideoUrl)
                                            }}
                                            onError={(error) => {
                                                console.error('视频加载错误:', error, processedVideoUrl)
                                            }}
                                            onPlay={() => {
                                                console.log('视频开始播放')
                                            }}
                                            config={{
                                                file: {
                                                    attributes: {
                                                        controlsList: 'nodownload',
                                                        playsInline: true
                                                    }
                                                }
                                            }}
                                        />
                                    </Suspense>
                                </div>
                            )
                        ) : firstImage ? (
                            <img src={firstImage} alt="product"
                                onClick={() => {
                                    ImageViewer.show({
                                        image: firstImage
                                    })
                                }}
                                onError={(e) => { e.target.src = defaultImg }} />
                        ) : null
                    }

                    <div className='pm-content'>
                        <div className='pm-name'><b>{activityTitle}</b></div>
                        <div className='pm-info hide'>
                            <div>&nbsp;</div>
                        </div>
                    </div>
                </div>

                {
                    contentType === 3 && param2 && (
                        <div className='m-t-sm' style={{ padding: '10px 10px 1px', backgroundColor: '#f5f5f5' }}>
                            <CouponList
                                ids={param2}
                                relateArea={param4}
                                getCouponCount={getCouponCount}
                                activityId={detail.activityId}
                                activityCoupons={[{ ...detail }]}
                                storeId={storeInfo.storeId}
                                placeFlag={detail.placeFlag}
                            />
                            {
                                from === 'transfer' && (
                                    <FloatingBubble
                                        className='coupon-bubble'
                                        style={{
                                            // '--background': 'var(--adm-color-primary)',
                                            '--initial-position-bottom': '400px',
                                            '--initial-position-right': '10px',
                                            '--edge-distance': '10px',
                                        }}
                                        axis='xy'
                                        onClick={() => setCouponVisible(true)}
                                    >
                                        <Badge
                                            content={couponCount > 0 ? couponCount : null}
                                        >
                                            <CouponOutline fontSize={28} />
                                        </Badge>

                                    </FloatingBubble>
                                )
                            }

                        </div>
                    )
                }
                <div className='desc-wrapper m-t-sm p10'>
                    <div className='desc-title'>{intl.get('h_detail').d('详情')}</div>
                    <div style={{ wordBreak: 'break-word' }}>
                        <Article list={content} />
                    </div>
                </div>
            </div>
            <div style={{ height: 60 }}></div>
            <div>
                {
                    [2, 3, 4, 5, 6, 7].includes(contentType) && param2 !== ''
                        ?
                        <div className='pm-detail-footer jm-flex'>
                            {contentType === 6 ?
                                <Button shape='rounded'
                                    block
                                    color='primary'
                                    onClick={e => {
                                        //todo 跳转分类
                                        console.log(detail, '/////detail/////')
                                        const text = `areaid=${param4 || scopeParam.areaId}&storeid=${detail.relateId}&hotel=${detail.shortName}&category=${param2}`
                                        navigate(`/carte?${text}`, { replace: isCurrentView })
                                        callback?.()
                                    }}>
                                    {intl.get('check').d('查看')}
                                </Button> : null}
                            {
                                (contentType === 2 || contentType === 7) && isURLValid(param2) && (
                                    <Button shape='rounded'
                                        block
                                        color='primary'
                                        onClick={e => {
                                            window.open(param2, '_blank')
                                        }}>
                                        {intl.get('redirect_n_view').d('跳转查看')}
                                    </Button>)
                            }
                            {
                                contentType === 4
                                    ?
                                    <Button shape='rounded' block color='primary' onClick={e => bookActivity(param2)} loading={loading} >{intl.get('h_book').d('Book')}</Button>
                                    :
                                    null
                            }
                            {/*
                                contentType === 3
                                    ?
                                    <Button shape='rounded' block color='primary' onClick={e => doGetCoupon(param2)} loading={loading} >GET</Button>
                                    :
                                    null
                             */}
                            {contentType === 5 ?
                                <Button shape='rounded'
                                    block
                                    color='primary'
                                    onClick={e => {
                                        if (isCurrentView) {
                                            // 如果已经在 /carte 页面，使用 Redux 直接添加购物车，不跳转
                                            dispatch(setAddCartFromActivityRedux(param2))
                                            // 关闭弹窗
                                            callback?.()
                                        } else {
                                            // 如果不在 /carte 页面，正常跳转（兼容旧逻辑）
                                            setAddCartFromActivity(param2)
                                            const text = `areaid=${param4 || scopeParam.areaId}&storeid=${detail.param5 || detail.relateId}&hotel=${detail.shortName || ''}&productid=${param2}`
                                            navigate(`/carte?${text}`, { replace: false })
                                            callback?.()
                                        }
                                        console.log(param2, '/////param2/////')
                                    }}>
                                    {intl.get('add_to_cart').d('Add to cart')}
                                </Button>
                                :
                                null
                            }
                        </div>
                        :
                        null
                }
                <div className='hide'>
                    <div className='pm-price jm-flex-item'>
                        <i>&nbsp;</i>
                    </div>
                    <div className='btn-primary' onClick={() => { }}>Book</div>
                </div>
                {
                    !hideHeader && (
                        <FloatingBubble
                            axis='xy'
                            style={{
                                '--background': 'var(--adm-color-primary)',
                                '--initial-position-bottom': '100px',
                                '--initial-position-right': '10px',
                                '--edge-distance': '10px',
                            }}
                        >
                            <div

                                onClick={() => {
                                    callback?.()
                                }}>
                                <LeftOutline fontSize={20} color='#fff' />
                            </div>
                        </FloatingBubble>
                    )}
            </div>
            {
                couponVisible && (
                    <Popup
                        position='bottom'
                        visible={couponVisible}
                        bodyStyle={{
                            width: '100vw',
                            height: '90vh',
                            padding: 0,
                            borderRadius: 0,
                            maxHeight: '90vh',
                            overflowY: 'auto',
                        }}
                        destroyOnClose
                        onMaskClick={() => { setCouponVisible(false) }}
                        onClose={() => { setCouponVisible(false) }}>
                        <Coupons
                            callback={() => { setCouponVisible(false) }}
                            relateArea={param4}
                            getCouponCount={getCouponCount}
                            from={from}
                            storeId={relateId}
                        />
                    </Popup>
                )
            }
        </div >
    )
}

export default PromotionDetail;